import React, { useEffect, useState } from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import "./topAds.m.css";

const TopAd = ({ lang, pageType, currentPath }) => {
  const [adType, setAdType] = useState();
  const [topId, setTopId] = useState("top-ad-id");

  const getAdTypes = () => {
    if (lang === "en") {
      switch (pageType) {
        case "home-page":
          return "EnPalo_HP_970x90_T1";
        default:
          return "EnPalo_ROS_728x90_T1";
      }
    } else {
      switch (pageType) {
        case "home-page":
          return "Home_728x90_T1";
        default:
          return "News_728x90_T1";
      }
    }
  };

  useEffect(() => {
    setAdType(getAdTypes());
    setTopId((prev) => `${prev}-` + 1);
  }, [currentPath, pageType]);

  return (
    <DfpContainer pages={["story-page", "story-public-preview-page", "story-preview"]}>
      <div styleName="top-ad-wrapper">
        <DfpComponent type={adType || getAdTypes()} slotId={topId} />
      </div>
    </DfpContainer>
  );
};

TopAd.propTypes = {
  adtype: string,
  lang: string,
  pageType: string,
  currentPath: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  loading: state.pageLoading,
  pageType: get(state, ["qt", "pageType"]),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  currentPath: get(state, ["qt", "currentPath"], ""),
});

export default connect(mapStateToProps)(TopAd);
